const Footer = () => {
  return (
    <div className="footer bg-violet-700 text-violet-50 py-10 text-center">
      <p>&copy; {new Date().getFullYear()} techTraid. All rights reserved.</p>
    </div>
  );
};

export default Footer;
